'use strict';

//import Raven from 'raven-js';

angular.module('docketbook')
  .factory('accessControl', function (Restangular, $rootScope, $state, $timeout, $stateParams, $cookies, $q, $window) {
    // get current organisation from cookies
    var currentOrgId = $cookies.get('currentOrg');
    var currentOrgGroupId = $cookies.get('currentOrgGroup');
    var currentUserItem = null;
    var currentOrganisation = null;
    var currentOrganisationGroup = null;
    var allowedOrganisations = [];
    var onboardingSessions = [];

    var configuration = null;
    var configured = false;
    var configurationPromise = null;

    var baseConfig = Restangular.one('configuration');
    var baseUser = Restangular.one('user/me');
    var baseOrganisations = Restangular.all('organisations');

    /******************************/
    /* Responsive Intercom Checks */
    /******************************/

    var initResponsiveChecks = function () {
      doUpdate();
      updateMode();
    }

    var doUpdate = function () {
      $(function () {
        var width = $(window).width();
        if (width <= 768) {
          $rootScope.mode = "mobile";
          /*if ($window.Intercom) {
            $window.Intercom("update", {
              hide_default_launcher: true
            });
          }*/
        } else {
          $rootScope.mode = "desktop";
          /*if ($window.Intercom) {
            $window.Intercom("update", {
              hide_default_launcher: false
            });
          }*/
        }
      });
    }

    var updateMode = function () {
      $timeout(function () {
        doUpdate();
        updateMode();
      }, 5000);
    }

    $timeout(function () {
      initResponsiveChecks();
    }, 2000);

    /**********************************/
    /* END Responsive Intercom Checks */
    /**********************************/

    function checkFcWidget(cb) {
      if (!window.FreshworksWidget) {
        window.setTimeout(() => checkFcWidget(cb), 200)
      } else {
        cb()
      }
    }

    var checkCompanyEnabled = function (orgId, cb) {
      baseOrganisations.getList().then(function (orgs) {
        var orgFound = null;
        for (var i = 0; i < orgs.length; i++) {
          if (orgs[i].id == orgId) {
            orgFound = orgs[i];
            break;
          }
        }
        if (orgFound && orgFound.accessAllowed) {
          cb(true);
        } else if (orgFound && orgFound.accessAllowed == false) {
          cb(false);
        }
      });
    }

    var getUsersPermissions = function (user, cb) {
      if (currentOrgId && currentOrgGroupId) {
        var urlString = "organisations/" + currentOrgId + "/groups/" + currentOrgGroupId + "/permissions?user=" + user.id;
        Restangular.one(urlString).get().then(function (permissionsRes) {
          cb(permissionsRes.permissions[user.id]);
        }, function (err) {
          cb(null);
        });
      } else {
        cb([]);
      }
    }

    var getAllowedOrganisations = function (successCb, failureCb) {
      if (allowedOrganisations != null && allowedOrganisations.length > 0) {
        successCb(allowedOrganisations);
        return;
      }
      baseOrganisations.getList().then(function (orgs) {
        allowedOrganisations = orgs;
        successCb(allowedOrganisations);
      }, function (err) {
        failureCb(err);
      });
    }

    var refereshAllowedOrganisation = function (successCb, failureCb) {
      baseOrganisations.getList().then(function (orgs) {
        allowedOrganisations = orgs;
        $rootScope.$emit('OrganisationsListRefreshed');
        successCb(allowedOrganisations);
      }, function (err) {
        if (err.status == 401) {
          return resolve([]);
        }
        failureCb(err);
      });
    }

    var getOnboardingSessions = function(successCb) {
      Restangular.all("onboarding").getList()
        .then(function(sessions) {
          sessions.forEach(session => {
            session.data = JSON.parse(session.data)
            session.updatedAt = moment(session.updatedAt).format('DD/MM/YY')
            session.createdAt = moment(session.createdAt).format('DD/MM/YY')
          });

          onboardingSessions = sessions;
          if (successCb) {
            successCb(sessions)
          }
        }, function(e) {
          console.error('failed to fetch onboarding sessions', e);
        });
    };

    getOnboardingSessions()

    var sampleCompanyTest = function (org) {
      if (!org) {
        return false;
      }
      if (!org.features) {
        return false;
      }
      if (!org.features.sampleCompany) {
        return false;
      }
      if (!org.features.sampleCompany.isSample) {
        return false;
      }
      return true;
    }

    return {
      logout: (apiVersion, redirectUrl) => {
        let url = `${DOCKETBOOK_API_URL}/${apiVersion}/logout${redirectUrl && redirectUrl !== '' ? '?redirectTo=' + encodeURIComponent(redirectUrl) : ''}`;

        window.location = url;
      },
      isSampleCompany: function () {
        return sampleCompanyTest(currentOrganisation);
      },
      hasSampleCompany: function () {
        if (!allowedOrganisations) {
          return false;
        }
        let hasSample = false;
        for (var i = 0; i < allowedOrganisations.length; i++) {
          const org = allowedOrganisations[i];
          if (sampleCompanyTest(org)) {
            hasSample = true;
            break;
          }
        }
        return hasSample;
      },
      currentUser: function () {
        return currentUserItem;
      },
      currentOrg: function () {
        return currentOrganisation;
      },
      currentOrgGroup: function () {
        return currentOrganisationGroup
      },
      allowedOrganisations: function () {
        return allowedOrganisations;
      },
      checkCompanyEnabled: function (orgId, cb) {
        return checkCompanyEnabled(orgId, cb);
      },
      refreshAndGetAllowedOrganisations: function (successCb, failureCb) {
        refereshAllowedOrganisation(successCb, failureCb);
      },
      onboardingSessions: function () {
        return onboardingSessions;
      },
      deleteSession: function (session, successCb) {
        Restangular.all("onboarding").one(session.id).remove().then(successCb)
      },
      getOrgPagePermissions: function (org, group, cb) {
        Restangular.all("organisations").one(org.id).all('groups').one(group.id).all('permissions').customGET("", { user: currentUserItem.id }).then(function (permissions) {
          cb(permissions);
        }, function (err) {
          cb([]);
        });
      },
      userHasPermission: function (permissionName) {
        // check if user is global admin on the group first
        if (currentOrganisation && currentOrganisation.globalAdministrators.indexOf(currentUserItem.id) != -1) {
          return true;
        }
        if (currentOrganisationGroup && currentOrganisationGroup.owners && currentOrganisationGroup.owners.indexOf(currentUserItem.id) != -1) {
          return true;
        }
        // check if user has finite permission second
        if (currentUserItem && currentUserItem.permissions) {
          if (currentUserItem.permissions.indexOf(permissionName) !== -1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
      refreshCurrentUser: function () {
        baseUser.get().then(function (user) {
          currentUserItem = user;
        });
      },
      ensureCurrentUser: function () {
        return $q(function (resolve, reject) {
          if (currentUserItem != null) {
            resolve(currentUserItem);
            return;
          }
          // fetch configuration if required
          if ((configuration === null) && (configurationPromise === null)) {
            configurationPromise = baseConfig.customGET().then(function (results) {
              configuration = results;

              $window.Stripe.setPublishableKey(configuration.stripe.public);
              //$window.configureIntercom();

              //$window.configureRaven(configuration.sentry.dsn);
              configured = true;
              configurationPromise = null;
              return true;
            })
          }
          baseUser.get().then(function (user) {
            if (user.id != null) {
              currentUserItem = user;
              if ((!configured) && (configurationPromise !== null)) {
                configurationPromise = configurationPromise.then(function () {

                  /*window.Intercom("boot", {
                    app_id: configuration.intercom.appId,
                    user_id: user.id,
                    name: user.name.full,
                    email: user.emailAddress,
                    user_hash: user.hash,
                    customer_launcher_selector: "#intercom-launcher"
                  });*/

                  checkFcWidget(function() {
                    console.log('configured fc')
                    //window.fcWidget.setExternalId();
                    window.FreshworksWidget('identify', 'ticketForm', {
                      name: user.name.full,
                      email: user.emailAddress,
                    })
                    window.FreshworksWidget('disable', 'ticketForm', ['name', 'email'])
                  })

                  /*Raven.setUserContext({
                    email: user.emailAddress,
                    name: user.name.full,
                    id: user.id
                  });*/
                  mixpanel.identify(currentUserItem.uuid);
                  mixpanel.people.set({
                    "$email": user.emailAddress,
                    "$first_name": user.name.first,
                    "$last_name": user.name.last
                  });
                })
              } else {
                checkFcWidget(function () {
                  console.log('configured fc')
                  //window.fcWidget.setExternalId();

                  window.FreshworksWidget('identify', 'ticketForm', {
                    name: user.name.full,
                    email: user.emailAddress,
                  })
                  window.FreshworksWidget('disable', 'ticketForm', ['name', 'email'])
                })

                /*Raven.setUserContext({
                  email: user.emailAddress,
                  name: user.name.full,
                  id: user.id
                });*/
                mixpanel.identify(currentUserItem.uuid);
                mixpanel.people.set({
                  "$email": user.emailAddress,
                  "$first_name": user.name.first,
                  "$last_name": user.name.last
                });
              }
              resolve(currentUserItem);
              return;
            }
            resolve();
          }, function (err) {
            console.error('received an error for ensureCurrentUser', err);
            reject(err);
          });
        });
      },
      ensureMyDocketbook: function () {
        return $q(function (resolve, reject) {
          $cookies.remove('currentOrgGroup');
          $cookies.remove('currentOrg');
          currentOrganisation = null;
          currentOrganisationGroup = null;
          currentOrgId = null;
          currentOrgGroupId = null;
          if (currentUserItem) {
            currentUserItem.permissions = [];
          }
          getAllowedOrganisations(function () {
            resolve(null);
          }, function (err) {
            reject(err);
          });
        });
      },
      getOrg: function (orgId, successCb, failureCb) {
        Restangular.all('organisations').one(orgId).customGET().then(successCb, failureCb)
      },
      getConnections: function (successCb) {
        Restangular.all('user').one(currentUserItem.id).all('connections').all('invitations').getList().then(invitations => {
          successCb && successCb(invitations)
        })
      },
      ensureCurrentOrgGroup: function (orgId, orgGroupId) {
        if (orgGroupId == 'home') {
          orgGroupId = null;
        }
        return $q(function (resolve, reject) {
          if (orgId == null) {
            $cookies.remove('currentOrgGroup');
            $cookies.remove('currentOrg');
            currentOrganisation = null;
            currentOrganisationGroup = null;
            currentOrgId = null;
            currentOrgGroupId = null;
            resolve(currentOrganisation);
          } else {
            if (currentOrganisation != null && currentOrganisation.id == orgId &&
              currentOrganisationGroup != null && currentOrganisationGroup.id == orgGroupId) {
              // check current org is not disabled
              resolve(currentOrganisation);
              return;
            }

            getAllowedOrganisations(function () {
              const isDev = process.env.NODE_ENV == 'development';

              var locatedOrg = null;
              if (allowedOrganisations && allowedOrganisations.length > 0) {
                for (var i = 0; i < allowedOrganisations.length; i++) {
                  if (allowedOrganisations[i].id == orgId) {
                    locatedOrg = allowedOrganisations[i];
                    break;
                  }
                }
              }

              var locatedOrgGroup = null;
              if (orgGroupId) {
                if (locatedOrg && locatedOrg.groups) {
                  for (var i = 0; i < locatedOrg.groups.length; i++) {
                    if (locatedOrg.groups[i].id == orgGroupId) {
                      locatedOrgGroup = locatedOrg.groups[i];
                      orgGroupId = locatedOrgGroup.id;
                      break;
                    }
                  }
                }
              } else {
                if (locatedOrg) {
                  for (var i = 0; i < locatedOrg.groups.length; i++) {
                    if (locatedOrg.groups[i].parent == null) {
                      locatedOrgGroup = locatedOrg.groups[i];
                      orgGroupId = locatedOrgGroup.id;
                      break;
                    }
                  }
                }
                if (locatedOrgGroup == null && locatedOrg.groups && locatedOrg.groups.length > 0) {
                  locatedOrgGroup = locatedOrg.groups[0];
                }
              }

              currentOrganisation = locatedOrg;

              // trim any trailing spaces and convert strings to proper values
              if (currentOrganisation.plan && currentOrganisation.plan.features) {
                var newFeatures = {}
                Object.keys(currentOrganisation.plan.features).forEach(feature => {
                  const featureVal = currentOrganisation.plan.features[feature]
                  if (!isNaN(featureVal)) {
                    newFeatures[feature.trim()] =
                      featureVal === true ? true
                        : featureVal === false ? false
                          : parseInt(featureVal)
                  } else {
                    newFeatures[feature.trim()] =
                      featureVal == 'true' ? true
                        : featureVal == 'false' ? false
                          : featureVal
                  }
                })
                currentOrganisation.plan.features = newFeatures
              }


              currentOrganisation.planFeatures = Object.assign(
                {
                  name: 'Free',
                  includedUsers: 10,
                  includedOrganisationGroups: 1,
                  ordersEnabled: false,
                  jobsEnabled: false,
                  reportingEnabled: false, // future
                  invoicesEnabled: false,  // future
                  accountingIntegrationEnabled: false, // future
                  ordersCreate: false,
                  jobsCreate: false,
                  jobsSubcontractorAllocation: false,
                  jobsAllocationsView: false,
                  docketsCreate: false,
                  docketsCreateFromJob: true,
                  docketsFiling: false,
                  docketsTimesheetsView: false,
                  docketsHistoricalDateLimit: 60,
                  docketsReports: false,
                  docketsCreateBatches: false,
                  docketsViewBatches: false,
                },
                currentOrganisation.plan ? currentOrganisation.plan.features : {},
                currentOrganisation.plan ? { name: currentOrganisation.plan.name } : {},
              )

              currentOrganisation.planFeatures.trialAvailable = true
              currentOrganisation.planFeatures.inTrial = false


              if (currentOrganisation.trial_end || isDev) {
                const trialEndDate = new Date(currentOrganisation.trial_end * 1000)
                currentOrganisation.planFeatures.trialAvailable = false
                if (moment().isBefore(trialEndDate) || isDev) {
                  currentOrganisation.planFeatures.inTrial = !isDev
                  currentOrganisation.planFeatures = Object.assign(
                    currentOrganisation.planFeatures,
                    {
                      ordersEnabled: true,
                      jobsEnabled: true,
                      reportingEnabled: true,
                      invoicesEnabled: true,
                      accountingIntegrationEnabled: true,
                      ordersCreate: true,
                      jobsCreate: true,
                      jobsSubcontractorAllocation: true,
                      jobsAllocationsView: true,
                      docketsCreate: true,
                      docketsCreateFromJob: true,
                      docketsFiling: true,
                      docketsTimesheetsView: true,
                      docketsHistoricalDateLimit: -1,
                      docketsReports: true,
                      docketsCreateBatches: true,
                      docketsViewBatches: true,
                    },
                  )
                }
              }

              if (isDev) {
                currentOrganisation.planFeatures.includedOrganisationGroups = 99
                currentOrganisation.planFeatures.includedUsers = 99
                currentOrganisation.betaAllowed = true
                currentOrganisation.features.docketSyncing = true
                currentOrganisation.features.canChangeOrderResources = true
                currentOrganisation.features.invoice.enabled = true
                currentOrganisation.features.reactBeta = true
              }

              if (currentOrganisation.features.dockets && currentOrganisation.features.dockets.listViewOrder) {
                const customColumns = currentOrganisation.features.dockets.listViewOrder.filter(x => x.split('-')[0] == 'customField')
                if (customColumns.length > 0) {
                  currentOrganisation.features.dockets.customColumns = customColumns.map(x => x.split('-')[1])

                }
              }

              currentOrganisationGroup = locatedOrgGroup;
              currentOrgId = orgId;
              currentOrgGroupId = orgGroupId;
              $cookies.put('currentOrgGroup', orgGroupId);
              $cookies.put('currentOrg', orgId);
              getUsersPermissions(currentUserItem, function (permissions) {
                currentUserItem.permissions = permissions;
                resolve(currentOrganisation);
              });
            }, function () {
              reject();
            });
          }
        });
      }
    }
  });



// WEBPACK FOOTER //
// ./src/factories/accessControl.js